import React from 'react';
import { CalendarRange } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from 'src/shared/components/ui/dropdown-menu';
import { Button } from 'src/shared/components/ui/button';
import Tooltip from 'src/shared/components/tooltip/Tooltip';

type HabitatBaselinePickerProps = {
    baselineYear: number;
    options: number[];
    onChange: (year: number) => void;
};

const NO_EARLIER_YEAR_TOOLTIP = 'There is no earlier year to compare against yet.';

const HabitatBaselinePicker = ({ baselineYear, options, onChange }: HabitatBaselinePickerProps) => {
    // With no earlier year there is nothing to choose: disable, and explain why in a tooltip.
    const disabled = options.length === 0;
    const trigger = (
        <DropdownMenuTrigger asChild>
            <Button variant='outline' disabled={disabled} data-testid='habitat-baseline-button'>
                <CalendarRange width={16} height={16} aria-hidden />
                Baseline {baselineYear}
            </Button>
        </DropdownMenuTrigger>
    );

    return (
        <DropdownMenu>
            {disabled ? (
                <Tooltip content={NO_EARLIER_YEAR_TOOLTIP} placement='bottom'>
                    {trigger}
                </Tooltip>
            ) : (
                trigger
            )}
            <DropdownMenuContent align='end'>
                <DropdownMenuRadioGroup value={String(baselineYear)} onValueChange={value => onChange(Number(value))}>
                    {options.map(year => (
                        <DropdownMenuRadioItem key={year} value={String(year)}>
                            {year}
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default HabitatBaselinePicker;
